var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92308 17.7692L3 19L4.23077 15.3077V4.23077C4.23077 3.90435 4.36044 3.5913 4.59125 3.36048C4.82207 3.12967 5.13512 3 5.46154 3H17.7692C18.0957 3 18.4087 3.12967 18.6395 3.36048C18.8703 3.5913 19 3.90435 19 4.23077V16.5385C19 16.8649 18.8703 17.1779 18.6395 17.4087C18.4087 17.6396 18.0957 17.7692 17.7692 17.7692H7.92308Z",
    stroke: "#8187A6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9231 8.53847H15.3077",
    stroke: "#8187A6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9231 12.2308H12.8462",
    stroke: "#8187A6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.cba39b8de1e6bac64489f8a05670cd40.svg";
export { ForwardRef as ReactComponent };